import { render, staticRenderFns } from "./UiLoader.vue?vue&type=template&id=049fbf60&scoped=true"
var script = {}
import style0 from "./UiLoader.vue?vue&type=style&index=0&id=049fbf60&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049fbf60",
  null
  
)

export default component.exports